import { CommonMessages } from '@app/constants/common.messages';

export const LanguageSelectorMessages = {
  CONFIRM_PAGE_RELOAD_TITLE: 'language-selector.confirm-page-reload-title',
  CONFIRM_PAGE_RELOAD_TEXT: 'language-selector.confirm-page-reload-text',
  CONFIRM_PAGE_RELOAD_CONFIRM_BUTTON: 'language-selector.confirm-page-reload-confirm-button',
  CONFIRM_PAGE_RELOAD_CANCEL_BUTTON: 'language-selector.confirm-page-reload-cancel-button',
  PREVIEW: CommonMessages.PREVIEW,
};
